import { graphql } from "react-relay";

// components
import "@components/event/EventRenderer.gql";

export const webAppCalendarFragments = {
  viewer: graphql`
    fragment WebAppCalendar_viewer on Viewer {
      user {
        id
        emails

        webAppFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
      }
    }
  `,
  org: graphql`
    fragment WebAppCalendar_org on Org
    @argumentDefinitions(
      weekStartDates: { type: "[LocalDate!]!" }
      calendarIds: { type: "[String!]!" }
      timeZone: { type: "String!" }
    ) {
      eventParentBaseWrapperByWeeksObject(
        weekStartDates: $weekStartDates
        calendarIds: $calendarIds
        includeAllDay: true
        timeZone: $timeZone
      ) {
        ... on EventParentBaseWrapperByWeekObjectList {
          list {
            eventParentBases {
              id
              timestamp
            }
            eventParentsByDay {
              eventParents {
                id
                eventParentBaseId
                eventParentBaseTimestamp

                events {
                  title
                  locked
                  isClockwiseEvent
                  isAllDay
                  calendarIds
                  organizer {
                    urnValue
                    responseStatus
                  }
                  attendees {
                    urnValue
                    responseStatus
                  }
                  creator {
                    urnValue
                  }
                  annotatedEvent {
                    userTags {
                      tag
                      states {
                        subjectType
                        subjectValue
                        value
                      }
                    }
                    orgTags {
                      tag
                      state {
                        subjectType
                        subjectValue
                        value
                      }
                    }
                  }
                  eventKey {
                    externalEventId
                  }
                  location
                  startTime {
                    dateOrDateTime
                    millis
                  }
                  endTime {
                    dateOrDateTime
                    millis
                  }
                }
              }
            }
          }
        }
      }
      userWorkingHours {
        id
        workingHours {
          daySettings {
            day
            setting {
              minSlot
              maxSlot
            }
          }
        }
      }
    }
  `,
};

export const webAppCalendarQuery = graphql`
  query WebAppCalendarQuery(
    $orgRelayId: ID!
    $weekStartDates: [LocalDate!]!
    $calendarIds: [String!]!
    $timeZone: String!
  ) {
    viewer: viewer {
      ...WebAppCalendar_viewer
    }
    org: node(id: $orgRelayId) {
      ...WebAppCalendar_org
        @arguments(weekStartDates: $weekStartDates, calendarIds: $calendarIds, timeZone: $timeZone)
    }
  }
`;
